<p>Please fill out the form below to complete your subscription setup.</p>
<p class="StripeSubscriptionForm__Note">
  We do not store any payment information on our servers. Payments are processed
  through our partner <a href="https://stripe.com" target="_blank">Stripe</a>.
  <img
    alt="Stripe Payment Processing"
    class="StripeSubscriptionForm__StripeBadge"
    src="assets/img/Powered by Stripe - blurple.svg"
  />
</p>

<ion-card class="StripeSubscriptionForm__Card">
  @if (error) {
    <div class="StripeSubscriptionForm__Error" [innerHTML]="error"></div>
  }

  <ion-card-content>
    <form class="StripeElement" [formGroup]="paymentForm">
      <ion-item>
        <ion-label position="floating">First Name</ion-label>
        <ion-input type="text" formControlName="firstName"></ion-input>
      </ion-item>
      <ion-item>
        <ion-label position="floating">Last Name</ion-label>
        <ion-input type="text" formControlName="lastName"></ion-input>
      </ion-item>
      <ion-item class="StripeSubscriptionForm__Email">
        <ion-label position="floating">Email</ion-label>
        <ion-input type="email" formControlName="email"></ion-input>
      </ion-item>
      <ion-item class="StripeSubscriptionForm__Select">
        <ion-label>Subscription Plan</ion-label>
        <ion-select
          class="form-control"
          formControlName="plan"
          placeholder="Select a plan"
        >
          @for (plan of plans; track plan) {
            <ion-select-option [value]="plan.id">{{
              plan.name
            }}</ion-select-option>
          }
        </ion-select>
      </ion-item>
      <input type="hidden" name="amount" />

      <div class="d-flex row justify-content-end">
        <div class="d-flex p-2 col justify-content-end">
          <ion-button
            class="StripeSubscriptionForm__Button"
            fill="outline"
            type="cancel"
            [disabled]="processingPayment"
            (click)="close()"
          >
            Cancel
          </ion-button>
          <ion-button
            [disabled]="paymentForm.invalid || paymentForm.pristine"
            [ngClass]="{
              'StripeSubscriptionForm__Button--Primary':
                paymentForm.valid && paymentForm.dirty
            }"
            class="StripeSubscriptionForm__Button"
            fill="solid"
            color="primary"
            type="submit"
            (click)="pay($event)"
          >
            Upgrade
          </ion-button>
        </div>
      </div>
    </form>
  </ion-card-content>
</ion-card>
